import * as angular from 'angular';

"use strict";
angular.module('AuthService', []);

export default 'AuthService'